<template>
    <transition appear name="fade" mode="out-in">
        <div v-if="active" class="ui-modal-message-wrapper" @click="reset">
            <div class="ui-info-screen">
                <Closer @click="reset"/>
                <component :is="$core.f().ucFirst( component )" />
            </div>
        </div>
    </transition>
</template>
<script>
import Online from "@/components/layout/parts/infoscreens/Online.vue";
import Chat from "@/components/layout/parts/infoscreens/Chat.vue";
import Members from "@/components/layout/parts/infoscreens/Members.vue";
import Closer from "@/components/layout/parts/Closer.vue";

export default {
    
    name:       'UiInfoScreen',
    components: { Closer, Online, Chat, Members },
    data()
    {
        return {
            active:    false,
            component: false
        }
    },
    
    created()
    {
        
        this.$core
            .getEventManager()
            .add( 'on-show-info-screen', ( which ) =>
            {
                
                this.component = which
                this.active = true
                
            } )
        
    },
    
    beforeUnmount()
    {
        
        this.$core
            .getEventManager()
            .remove( 'on-show-info-screen' )
        
    },
    
    methods: {
        
        reset()
        {
            this.active = false
            this.component = false
        }
        
    }
}
</script>